import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("doenies_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const org = localStorage.getItem("slackr_org");
  if (org) config.headers["X-Org-Id"] = org;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error.response?.status === 402) {
      const detail = error.response.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Een licentie is vereist om verder te gaan.");
      window.dispatchEvent(new CustomEvent("doenies-paywall"));
    }
    return Promise.reject(error);
  }
);

export function formatError(detail) {
  if (detail == null) return "Er ging iets mis. Probeer opnieuw.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
